import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { Autocomplete, Checkbox, ListItemText, Popper, TextField } from '@mui/material';

import Analytics from '../../../Services/AnalyticsService';

function FilterSelect({ options, onChange, attribute, value = [], placeholder }: any) {
  const intl = useIntl();

  const CustomPopper = (props: any) => {
    return <Popper {...props} style={{ width: 'auto', minWidth: props.style.width }} />;
  };

  return (
    <Autocomplete
      multiple
      options={options}
      getOptionLabel={(option: any) => option.label}
      PopperComponent={CustomPopper}
      disableCloseOnSelect
      value={options.filter((option: any) => value.includes(option.id))}
      onChange={(_event: any, newValue: any) => {
        const newIds = newValue.map((item: any) => item.id);
        Analytics.track('Space', 'Search - Filter', `Filter post by ${attribute}: ${newIds}`);
        onChange(attribute, newIds);
      }}
      renderInput={(params: any) => (
        <TextField
          {...params}
          variant="outlined"
          label={<FormattedMessage id={`POSTS.FILTER_BY_${attribute.toUpperCase()}`} />}
          placeholder={placeholder as string}
          InputProps={{
            ...params.InputProps,
            inputProps: {
              ...params.inputProps,
              'aria-label': intl.formatMessage({
                id: `POSTS.FILTER_BY_${attribute.toUpperCase()}`,
              }),
            },
          }}
        />
      )}
      limitTags={1}
      renderOption={(props: any, option: any, { selected }: any) => (
        <li {...props}>
          <Checkbox checked={selected} disableRipple />
          <ListItemText primary={option.label} />
        </li>
      )}
    />
  );
}

export default FilterSelect;
